import script from "./AlocateTeacher.vue?vue&type=script&setup=true&lang=js"
export * from "./AlocateTeacher.vue?vue&type=script&setup=true&lang=js"

import "./AlocateTeacher.vue?vue&type=style&index=0&id=3d63f717&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d63f717"]])

export default __exports__